if (window.location.pathname === '/account/register' || window.location.pathname.includes('/pages/')) {
    function restyleDefaultRF() {
      let field = document.querySelectorAll(".form-vertical .field, .formbuilder-text, .formbuilder-date, .formbuilder-number")
      if (field.length) {
          field.forEach((item) => {
              item.classList.add("field");
              let label = item.querySelector("label");
              let input = item.querySelector("input");
              if (input) {
                  input.placeholder = " ";
                  if (label) {
                      input.after(label)
                  }
              }
          });
      }
    const elementAddFieldClass = $('.formbuilder-file, .formbuilder-select, .formbuilder-textarea ');
    elementAddFieldClass.addClass("field");
    const country = $('.formbuilder-autocomplete.form-group.field-country-field');
    country.addClass("field");
    const countryChildren = country.children();
    countryChildren[1].placeholder = ' ';
    countryChildren[2].placeholder = ' ';
    countryChildren[2].setAttribute('type','text');
    countryChildren[2].style.display = "none";
    countryChildren[3].after(countryChildren[0]);

    const formbuilderTextareas = document.querySelectorAll(".formbuilder-textarea");
    formbuilderTextareas.forEach(formbuilderTextarea => {
    const formbuilderLabel = formbuilderTextarea.querySelector(".formbuilder-textarea label");
    const formbuilderInput = formbuilderTextarea.querySelector(".formbuilder-textarea textarea");
    formbuilderInput.addEventListener("click", () => {
      formbuilderTextarea.classList.add("handle-transition");
    });

    formbuilderInput.addEventListener("focus", event => {
      formbuilderTextarea.classList.add("handle-transition");
    });

    formbuilderInput.addEventListener("blur", event => {
      if (event.target.value) {
        formbuilderTextarea.classList.add("handle-transition");
      } else {
        formbuilderTextarea.classList.remove("handle-transition");
      }
    });
})
    }
    function restyleCustomRF() {
      const elements = document.querySelectorAll('.page-width');
      elements.forEach(function(element) {
          if (element.querySelector('.form-vertical')) {
              element.classList.add('customer');
          }
      });
      const registerForm = document.getElementById('RegisterForm');
      if (registerForm) {
          registerForm.removeAttribute('id');
       registerForm.setAttribute("id", "create_customer");
      }
      $(".formbuilder-date, .formbuilder-number, .formbuilder-text, .formbuilder-textarea, .formbuilder-file").addClass("field")
      $(".customer .field").each((_, item) => {
          const label = $(item).find("label");
          const input = $(item).find("input");
          if(label && input) {
              input.attr("placeholder", " ")
              input.after(label);
          }
      })
      
        const country = $('.formbuilder-autocomplete.form-group.field-country-field');
      if(country.length){
        country.addClass("field");
        const countryChildren = country.children();
        countryChildren[1].placeholder = ' ';
        countryChildren[2].placeholder = ' ';
        countryChildren[2].setAttribute('type','text');
        countryChildren[2].style.display = "none";
        countryChildren[3].after(countryChildren[0]);
      }
      const formbuilderTextareas = document.querySelectorAll(".formbuilder-textarea");
    formbuilderTextareas.forEach(formbuilderTextarea => {
    const formbuilderLabel = formbuilderTextarea.querySelector(".formbuilder-textarea label");
    const formbuilderInput = formbuilderTextarea.querySelector(".formbuilder-textarea textarea");
    formbuilderInput.addEventListener("click", () => {
      formbuilderTextarea.classList.add("handle-transition");
    });

    formbuilderInput.addEventListener("focus", event => {
      formbuilderTextarea.classList.add("handle-transition");
    });

    formbuilderInput.addEventListener("blur", event => {
      if (event.target.value) {
        formbuilderTextarea.classList.add("handle-transition");
      } else {
        formbuilderTextarea.classList.remove("handle-transition");
      }
    });
    })
    }
  const loop = setInterval(() => {
    if(document.querySelector("#bss-b2b-registration-form-render")){
      clearInterval(loop);
      if (window.location.pathname.includes('/pages/')) {
        restyleCustomRF();
    } else {
       restyleDefaultRF();
    }
    }
  }, 100)
setTimeout(() => {
  clearInterval(loop);
}, 8000)
  
//     const observer = new MutationObserver(function(mutationsList, observer) {
//     for(let mutation of mutationsList) {
//         if (mutation.type === 'childList') {
//             mutation.addedNodes.forEach(function(node) {
//                 if (node.classList && node.classList.contains('rendered-form')) {
//                     observer.disconnect();
//                   console.log(123)
//                     if (window.location.pathname.includes('/pages/')) {
//                       setTimeout(() => {
//                         restyleCustomRF();
//                       }, 300)
//                     } else {
//                       setTimeout(() => {
//                        restyleDefaultRF();
//                       }, 300)
//                     }
//                 }
//             });
//         }
//     }
// });

observer.observe(document.body, { childList: true, subtree: true });

setTimeout(function() {
    observer.disconnect();
}, 8000);

}

document.addEventListener("BSS:changeVariant", e => {
  setTimeout(e => {
    BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, 0, 0)
  }, 500)
  setTimeout(e => {
    BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, 0, 0)
  }, 1000)
})